module.exports = __webpack_public_path__ + "static/media/bubble_4.d92d2535.png";